// extracted by mini-css-extract-plugin
export default {"login_section":"register_login_section__aAZ4R","form":"register_form__flGHS"};